import { useTranslation } from 'react-i18next';

export const useGetTrendsSearchResults = () => {
  const { t } = useTranslation();

  const getSearchResults = (rowData, totalData, id) => {
    if (Array.isArray(rowData) && rowData.length > 0)
      return [
        ...rowData.map(row => ({
          ...row,
          id: row[id],
          ...row.data.reduce((timeUnits, timeUnit, i) => {
            timeUnits[`granularity${i + 1}`] = timeUnit;
            return timeUnits;
          }, {}),
        })),
        {
          id: 'total',
          displayInfoTitle: t(
            'page.loyaltyPerformanceReport.tabs.locationLoyaltyPerformance.grid.totalRow.label',
          ),
          ...totalData.reduce(
            (acc, day, i) => ({
              ...acc,
              [`granularity${i + 1}`]: day,
            }),
            {},
          ),
        },
      ];
    return [];
  };

  return { getSearchResults };
};
